// src/components/Pagination.js
import React from "react";

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}) {
  if (totalPages <= 1) return null;

  const MAX_VISIBLE = 5;
  const pages = [];

  let start = Math.max(1, currentPage - Math.floor(MAX_VISIBLE / 2));
  let end = Math.min(totalPages, start + MAX_VISIBLE - 1);

  if (end - start < MAX_VISIBLE - 1) {
    start = Math.max(1, end - MAX_VISIBLE + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div className="flex justify-center items-center gap-1 mt-6 flex-wrap">
      {/* PREV */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-3 py-1 rounded-lg border bg-white dark:bg-gray-800 dark:text-white
                   disabled:opacity-50"
      >
        Prev
      </button>

      {/* FIRST */}
      {start > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            className="px-3 py-1 rounded-lg border bg-white dark:bg-gray-800 dark:text-white"
          >
            1
          </button>
          <span className="px-2 text-gray-500">…</span>
        </>
      )}

      {/* PAGES */}
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`px-3 py-1 rounded-lg border
            ${
              page === currentPage
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white dark:bg-gray-800 dark:text-white"
            }`}
        >
          {page}
        </button>
      ))}

      {/* LAST */}
      {end < totalPages && (
        <>
          <span className="px-2 text-gray-500">…</span>
          <button
            onClick={() => onPageChange(totalPages)}
            className="px-3 py-1 rounded-lg border bg-white dark:bg-gray-800 dark:text-white"
          >
            {totalPages}
          </button>
        </>
      )}

      {/* NEXT */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-3 py-1 rounded-lg border bg-white dark:bg-gray-800 dark:text-white
                   disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
}
